<div>
    <!-- Service field -->
    <div>
        <li>
            <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-xs-3"
                    [ngClass]="{'required': baseVariableService.selectedVariable.propertyObj['service'].required}"
                    title="{{locale['LABEL_VARIABLE_PROPERTIES_'+ 'service'.toUpperCase()] || 'service'}}">
                    {{locale.LABEL_SERVICE}}
                </label>
                <wms-variables-template style="display: inline-block;"
                    (onModelChange)="handleModelChange($event)"
                    [templateType]="'var-prop-' + (baseVariableService.selectedVariable.propertyObj['service'].widgettype || baseVariableService.selectedVariable.propertyObj['service'].type || 'string')"
                    propertyName="service"
                    [selectedService]="selectedVarService" 
                    [selectedVariable]="baseVariableService.selectedVariable"></wms-variables-template>
                <i class="wms wms-help" container="body"
                    tooltip="{{(locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory] && locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory]['service'.toUpperCase()]) || locale['MESSAGE_HELP_VARIABLE']['service'.toUpperCase()]}}"
                    placement="right"></i>
            </div>
        </li>
    </div> 
</div>
